var _ellipse, _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrashIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 150,
    viewBox: "0 0 182 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 104,
    cy: 133.5,
    rx: 59,
    ry: 15.5,
    fill: "#EFEFEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67 70.909H70.3141V83.0074C70.3141 85.5601 72.3888 87.6075 74.9754 87.6075H75.7567V108.241C75.7567 110.767 77.8314 112.815 80.3911 112.842C81.3072 112.842 82.2232 112.868 82.9507 112.868C91.6805 112.868 98.7667 119.861 98.7667 128.476H98.9015V133.582C98.9015 136.134 100.976 138.182 103.563 138.182H123.582C126.169 138.182 128.243 136.108 128.243 133.582V125.658V112.788V87.6075H129.025C131.611 87.6075 133.686 85.5335 133.686 83.0074V70.909H137V66.043H67V70.909Z",
    fill: "#FFA800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9508 115.922C75.9454 115.922 70.2603 121.532 70.2603 128.472C70.2603 135.386 75.9454 140.996 82.9508 140.996C89.9562 140.996 95.6413 135.386 95.6413 128.472C95.6413 121.532 89.9562 115.922 82.9508 115.922ZM82.9508 134.854C79.3673 134.854 76.4573 131.982 76.4573 128.472C76.4573 124.936 79.3673 122.064 82.9508 122.064C86.5343 122.064 89.4442 124.936 89.4442 128.472C89.4173 131.982 86.5343 134.854 82.9508 134.854Z",
    fill: "#0552BC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5935 41.0485L118.732 17.9949L107.092 16.0539C105.691 15.8145 104.263 16.24 103.239 17.1706L101.272 18.9788L98.5781 18.1013C97.3656 17.7024 96.207 17.862 95.4796 18.5533L83.1124 29.8807L70.7721 41.2081C70.0446 41.8728 69.7752 42.9896 70.0985 44.2393L70.7721 46.9781L68.7783 48.7863C67.7544 49.7169 67.2155 51.0996 67.3502 52.4823L68.428 64.1021L93.5935 41.0485Z",
    fill: "#FFA800"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M109.706 62.531C112.185 62.531 114.179 60.5634 114.179 58.1171C114.179 55.6708 112.185 53.7031 109.706 53.7031C107.227 53.7031 105.233 55.6708 105.233 58.1171C105.233 60.5634 107.227 62.531 109.706 62.531Z",
    fill: "#0552BC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M103.617 45.3281C102.027 45.3281 100.734 46.6045 100.734 48.1733C100.734 49.7421 102.027 51.0184 103.617 51.0184C105.206 51.0184 106.5 49.7421 106.5 48.1733C106.473 46.5779 105.179 45.3281 103.617 45.3281Z",
    fill: "#0552BC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9946 58.1186C94.9946 59.6874 96.2879 60.9637 97.8776 60.9637C99.4673 60.9637 100.761 59.6874 100.761 58.1186C100.761 56.5498 99.4673 55.2734 97.8776 55.2734C96.261 55.2734 94.9946 56.5498 94.9946 58.1186Z",
    fill: "#0552BC"
  })));
}

export default SvgTrashIcon;